import { FC, useState } from 'react';
import { LayoutCarousel } from '@silverfort/sf-components';
import { ProtocolType, ProtocolTypeSummary } from '../../types';
import { useProtocolTypeData } from './hooks/useProtocolTypeData';
import usePaginatedDonutChart from '../../hooks/usePaginatedDonutChart';

interface ProtocolTypeChartProps {
    protocolTypeSummary?: ProtocolTypeSummary;
    isLoading: boolean;
    className?: string;
    onClick: (protocolType: ProtocolType) => void;
    innerCircleEmptyStateClassName?: string;
}

enum DropdownOption {
    DENIED = 'denied',
    ALL = 'all'
}

const ProtocolTypeChart: FC<ProtocolTypeChartProps> = ({ protocolTypeSummary, isLoading, className, onClick, innerCircleEmptyStateClassName }) => {
    const [selectedDropdownOption, setSelectedDropdownOption] = useState<DropdownOption>(DropdownOption.DENIED);
    const relevantProtocolTypeSummary =
        selectedDropdownOption === DropdownOption.DENIED ? protocolTypeSummary?.denied : protocolTypeSummary?.all;
    const chartData = useProtocolTypeData(onClick, relevantProtocolTypeSummary);
    const pages = usePaginatedDonutChart({ chartData, isLoading, innerCircleEmptyStateClassName});

    return (
        <LayoutCarousel
            title="Protocol type"
            className={className}
            contentClassName="flex flex-1 flex-col justify-center px-6 flex-shrink-0 h-full min-h-[150px]"
            pages={pages}
            dropDownProps={{
                variant: 'trigger',
                items: [
                    { value: DropdownOption.DENIED, title: 'Denied' },
                    { value: DropdownOption.ALL, title: 'All authentications' }
                ],
                size: 'large',
                width: '120px',
                className: '[&]:w-[120px] border [&]:border-sf-gray-100 bg-transparent',
                selectedItems: selectedDropdownOption,
                onChange: (value) => setSelectedDropdownOption(value as DropdownOption)
            }}
        />
    );
};

export default ProtocolTypeChart;
